/**
* 4G配置
*/
<template>
	<div class="bg-gradient-to-b from-gray-50 to-blue-50 flex justify-center items-center" style="height: 93.45vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false" style="z-index: 2000;">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="bg-white rounded-xl shadow-xl p-5 border border-gray-100" style="width: 90%;">

			<div class="mb-2 p-5 bg-gray-50 rounded-xl border border-gray-200 flex items-center">
				<h2 class="text-lg font-bold text-gray-800 mb-0 flex items-center gap-2">
					<i class="fas fa-route text-blue-600"></i>
					<!-- 订阅 MQTT 主题路径 -->
					{{ $t('language000360') }}
				</h2>
				<div class="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-200 ml-4">
					<i class="fas fa-link text-gray-400"></i>
					<code class="text-sm text-blue-600 font-mono flex-1">{{ mqttUrl }}</code>
					<button @click="copyCode(mqttUrl)"
						class="text-gray-400 hover:text-blue-600 transition-colors duration-200 !rounded-button whitespace-nowrap">
						<i class="fas fa-copy"></i>
					</button>
				</div>

				<h2 class="text-lg font-bold text-gray-800 mb-0 flex items-center gap-4" style="margin-left: 50px;">
					<i class="fas fa-hashtag text-blue-600"></i>
					MQTT ClientId
				</h2>
				<div class="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-200 ml-4">
					<i class="fas fa-link text-gray-400"></i>
					<code
						class="text-sm text-blue-600 font-mono flex-1">{{ mqttClientId }}_{{ $t('language000411') }}</code>
					<button @click="copyCode(mqttClientId)"
						class="text-gray-400 hover:text-blue-600 transition-colors duration-200 !rounded-button whitespace-nowrap">
						<i class="fas fa-copy"></i>
					</button>
				</div>

			</div>


			<div class="mb-4 p-5 bg-gray-50 rounded-xl border border-gray-200 flex items-center">

				<h2 class="text-lg font-bold text-gray-800 mb-0 flex items-center gap-2">
					<i class="fas fa-hashtag text-blue-600"></i>
					URL
				</h2>
				<div class="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-200 ml-4">
					<i class="fas fa-link text-gray-400"></i>
					<code class="text-sm text-blue-600 font-mono flex-1">{{ mqttURL }}</code>
					<button @click="copyCode(mqttURL)"
						class="text-gray-400 hover:text-blue-600 transition-colors duration-200 !rounded-button whitespace-nowrap">
						<i class="fas fa-copy"></i>
					</button>
				</div>

				<h2 class="text-lg font-bold text-gray-800 mb-0 flex items-center gap-2" style="margin-left: 50px;">
					<i class="fas fa-hashtag text-blue-600"></i>
					<!-- 登录账号 -->
					{{ $t('language000096') }}
				</h2>
				<div class="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-200 ml-4">
					<i class="fas fa-link text-gray-400"></i>
					<code class="text-sm text-blue-600 font-mono flex-1">{{ username }}</code>
					<button @click="copyCode(username)"
						class="text-gray-400 hover:text-blue-600 transition-colors duration-200 !rounded-button whitespace-nowrap">
						<i class="fas fa-copy"></i>
					</button>
				</div>

				<h2 class="text-lg font-bold text-gray-800 mb-0 flex items-center gap-2" style="margin-left: 50px;">
					<i class="fas fa-hashtag text-blue-600"></i>
					<!-- 密码登录 -->
					{{ $t('language000119') }}
				</h2>
				<div class="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-200 ml-4">
					<i class="fas fa-link text-gray-400"></i>
					<code class="text-sm text-blue-600 font-mono flex-1">{{ password }}</code>
					<button @click="copyCode(password)"
						class="text-gray-400 hover:text-blue-600 transition-colors duration-200 !rounded-button whitespace-nowrap">
						<i class="fas fa-copy"></i>
					</button>
				</div>


			</div>

			<!-- 总开关 -->
			<div class="mb-5 bg-blue-50 p-5 rounded-xl border-2 border-blue-100">
				<div class="flex items-center justify-between mb-2">
					<div>
						<span class="text-xl font-bold text-blue-900 flex items-center gap-2">
							<i class="fas fa-power-off text-blue-600 text-2xl"></i>
							<!-- 开通mqtt消息订阅功能 -->
							{{ $t('language000361') }}
						</span>
					</div>
					<el-switch v-model="masterSwitch" active-color="#2563eb" inactive-color="#999"
						:disabled="masterSwitch" @change="toggleMasterSwitch">
					</el-switch>
				</div>
				<p class="text-sm text-gray-600 mb-4 bg-white p-3 rounded-lg border border-blue-100">
					<i class="fas fa-exclamation-circle text-blue-500 mr-2"></i>
					<!-- 开通后，设备将返回4G指令到订阅的主题中 -->
					{{ $t('language000362') }}
				</p>
				<div class="flex items-center gap-2">
					<span class="text-sm">
						<!-- 状态 -->
						{{ $t('language000371') }}：
					</span>
					<span :class="['text-sm font-bold', masterSwitch ? 'text-blue-600' : 'text-red-500']">
						<!-- '已开启' : '已关闭' -->
						{{ masterSwitch ? $t('language000363') : $t('language000364') }}
					</span>
				</div>
			</div>
			<!-- 子开关组 -->
			<div>
				<!-- 开关1 -->
				<div
					class="pb-5 border-b border-gray-100 hover:bg-gray-50 rounded-lg p-4 transition-colors duration-200">
					<div class="flex items-center justify-between mb-2">
						<div>
							<span class="text-lg font-semibold text-gray-700 flex items-center gap-2">
								<i class="fas fa-paper-plane text-blue-600"></i>
								<!-- Mqtt消息的推送 -->
								{{ $t('language000365') }}
							</span>
						</div>
						<el-switch v-model="switch1" active-color="#2563eb" inactive-color="#999"
							:disabled="!masterSwitch" @change="toggleSwitch1">
						</el-switch>
					</div>
					<p class="text-sm text-gray-600 mb-2">
						<!-- 开启后接收MQTT消息，关闭后不接收MQTT消息 -->
						{{ $t('language000366') }}
					</p>
					<div class="flex items-center gap-2">
						<span class="text-sm">
							<!-- 状态 -->
							{{ $t('language000371') }}：
						</span>
						<span :class="['text-sm font-medium',switch1 ? 'text-blue-600' : 'text-gray-500']">
							<!-- '已开启' : '已关闭' -->
							{{ switch1 ? $t('language000363') : $t('language000364') }}
						</span>
					</div>
				</div>
				<!-- 开关2 -->
				<div
					class="py-5 border-b border-gray-100 hover:bg-gray-50 rounded-lg p-4 transition-colors duration-200">
					<div class="flex items-center justify-between mb-2">
						<div>
							<span class="text-lg font-semibold text-gray-700 flex items-center gap-2">
								<i class="fas fa-shield-alt text-blue-600"></i>
								<!-- MQTT消息加密 -->
								{{ $t('language000367') }}
							</span>
						</div>
						<el-switch v-model="switch2" active-color="#2563eb" inactive-color="#999"
							:disabled="!masterSwitch" @change="toggleSwitch2">
						</el-switch>
					</div>
					<p class="text-sm text-gray-600 mb-2">
						<!-- 开启后进行AES加密传输 -->
						{{ $t('language000368') }}
					</p>
					<div class="flex items-center gap-2">
						<span class="text-sm">
							<!-- 状态 -->
							{{ $t('language000371') }}：
						</span>
						<span
							:class="['text-sm font-medium', canToggleSwitch2 && switch2 ? 'text-blue-600' : 'text-gray-500']">
							<!-- '已开启' : '已关闭' -->
							{{ switch2 ? $t('language000363') : $t('language000364') }}
						</span>
					</div>
				</div>
				<!-- 开关3 -->
				<div class="pt-5 hover:bg-gray-50 rounded-lg p-4 transition-colors duration-200">
					<div class="flex items-center justify-between mb-2">
						<div>
							<span class="text-lg font-semibold text-gray-700 flex items-center gap-2">
								<i class="fas fa-sync-alt text-blue-600"></i>
								<!-- 加密密钥的环境 -->
								{{ $t('language000369') }}
							</span>
						</div>
						<el-switch v-model="switch3" active-color="#2563eb" inactive-color="#999" :disabled="!switch2"
							@change="toggleSwitch3">
						</el-switch>
					</div>
					<p class="text-sm text-gray-600 mb-2">
						<!-- 正式环境和测试环境之间的密钥进行切换 -->
						{{ $t('language000370') }}
					</p>
					<div class="flex items-center gap-2">
						<span class="text-sm">
							<!-- 状态 -->
							{{ $t('language000371') }}：
						</span>
						<span
							:class="['text-sm font-medium', canToggleSwitch3 && switch3 ? 'text-blue-600' : 'text-gray-500']">
							<!-- '已开启' : '已关闭' -->
							{{ switch3 ? $t('language000177') : $t('language000178') }}
						</span>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	// 引入公用方法
	import {
		getError
	} from '../../../../../src/utils/StringUtil.js';


	export default {
		mounted() {
			this.getPlatformMqttSubscribeInfoRes();
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				masterSwitch: false,
				switch1: false,
				switch2: false,
				switch3: false,
				mqttUrl: "", //MQTT 主题理解
				mqttClientId: "", //MQTT mqttClientId
				username: '', //MQTT登录账号
				password: '', //MQTT登录密码
				mqttURL: '', //MQTT 连接地址
			};
		},
		computed: {
			canToggleSwitch2() {
				return this.masterSwitch;
			},
			canToggleSwitch3() {
				return this.masterSwitch && this.switch2;
			},
		},
		methods: {
			getPlatformMqttSubscribeInfoRes() { //查询Mqtt订阅主题信息
				this.loadingData = true;
				axios.get(this.$p_url_Developers + '/device/common/getPlatformMqttSubscribeInfoRes', {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							if (response.data.data != null) {
								this.mqttUrl = response.data.data.topicPath; //订阅路径
								this.mqttClientId = response.data.data.mqttClientId; //订阅ClientId

								this.username = response.data.data.mqttUserInfoRes.username //登录账号
								this.password = response.data.data.mqttUserInfoRes.password //登录密码
								this.mqttURL = response.data.data.mqttUrl //url

								this.switch1 = response.data.data.openFlag == "1" //1 开启，0 关闭
								this.switch2 = response.data.data.encryptFlag == "1" //1 是，0 否
								this.switch3 = response.data.data.encryptEnvironment == "1" //1 PRODUCT，0 TEST 

								this.masterSwitch = (this.switch1 || this.switch2 || this
									.switch3) //三个按钮中，只要有一个是开启的，总开关就是开启状态
							}
						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			platformOpen4GSubscribe() { //平台开通mqtt消息订阅功能，用于接收设备消息
				const requestData = {};
				this.loadingData = true;
				axios.post(this.$p_url_Developers + '/device/common/platformOpen4GSubscribe', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							this.getPlatformMqttSubscribeInfoRes();
						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			updateMqttSubscribeOpenFlag() { //修改是否开启或关闭Mqtt消息的推送
				const requestData = {};
				this.loadingData = true;
				axios.post(this.$p_url_Developers + '/device/common/updateMqttSubscribeOpenFlag', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							this.getPlatformMqttSubscribeInfoRes();
						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			updateMqttEncryptFlag() { //平台修改是否加密来自mqtt的消息
				const requestData = {};
				this.loadingData = true;
				axios.post(this.$p_url_Developers + '/device/common/updateMqttEncryptFlag', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							this.getPlatformMqttSubscribeInfoRes();
						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			updateMqttEncryptEnvironment() { //修改mqtt消息加密密钥的环境
				const requestData = {};
				this.loadingData = true;
				axios.post(this.$p_url_Developers + '/device/common/updateMqttEncryptEnvironment', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							this.getPlatformMqttSubscribeInfoRes();
						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			copyCode(key) {
				const input = document.createElement('input'); // 创建一个临时的输入框
				input.value = key; // 将要复制的内容赋值给输入框
				document.body.appendChild(input); // 将输入框添加到文档中
				input.select(); // 选中输入框中的文本
				input.setSelectionRange(0, 99999); // 对于移动设备
				document.execCommand('copy'); // 执行复制命令
				document.body.removeChild(input); // 移除临时输入框
				this.$message({
					message: this.$t('language000064'),
					type: 'success'
				});
			},
			toggleMasterSwitch(newValue) { //第一个开关的开启  开启后无法关闭
				if (!this.masterSwitch) {
					this.masterSwitch = !this.masterSwitch;
					if (!this.masterSwitch) {
						this.switch1 = false;
						this.switch2 = false;
						this.switch3 = false;
					}
				}
				this.platformOpen4GSubscribe()
				console.error('单击了第一个按钮：', newValue);
			},
			toggleSwitch1(newValue) {
				this.updateMqttSubscribeOpenFlag()
				console.error('单击了第二个按钮：', newValue);
			},
			toggleSwitch2(newValue) {
				if (this.canToggleSwitch2) {
					if (!this.switch2) {
						this.switch3 = false;
					}
				}
				this.updateMqttEncryptFlag()
				console.error('单击了第三个按钮：', newValue);
			},
			toggleSwitch3(newValue) {
				this.updateMqttEncryptEnvironment()
				console.error('单击了第四个按钮：', newValue);
			},
		},
	};
</script>

<style scoped>
	.min-h-screen {
		min-height: 100vh;
		background-attachment: fixed;
	}
</style>